<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-payments'>{{translations('navbar.sale_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-payments'>{{translations('deposit.archive_deposit')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('invoice.deposit_detail')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('invoice.payment_day')}}</th>
                <td>{{$invoiceTools.formatDateAt(paymentsInfo.paid_at)}}</td>
              </tr>
              <tr>
                <th>{{translations('invoice.supplier')}}</th>
                <td>{{paymentsInfo.client_name}}</td>
              </tr>
              <tr>
                <th>{{translations('deposit.name')}}</th>
                <td>{{paymentsInfo.name}}</td>
              </tr>
              <tr>
                <th>{{translations('deposit.total_deposit_amount')}}</th>
                <td>{{Number(paymentsInfo.total_paid).toLocaleString()}}</td>
              </tr>
              <tr>
                <th>{{translations('invoice.transfer_fee')}}</th>
                <td>{{Number(paymentsInfo.total_fee).toLocaleString()}}</td>
              </tr>
              <tr>
                <th>{{translations('invoice.remarks')}}</th>
                <td>{{paymentsInfo.memo}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_updated_by')}}</th>
                <td>{{paymentsInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_update_time')}}</th>
                <td>{{$invoiceTools.formatDateAt(paymentsInfo.updated_at)}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deletePayments()" data-href='#'>{{translations('deposit.deposit_cancellation')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end">
            <div class="form-check">
              <label class="form-check-label">{{translations('common.tax_included')}}</label>
            </div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-800'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('invoice.item_name')}}</th>
                  <th>{{translations('invoice.amount_money')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(detail, i) in paymentsDetails">
                  <tr :key="i">
                    <td>
                      <button tabindex="-1" @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ detail.item_name }}</td>
                    <td>{{ Number(detail.paid).toLocaleString() }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button
                      class='btn-change plus'
                      type='button'
                      data-toggle='modal'
                      data-target='#SinglePaymentsModal'
                    >
                      <i></i>
                    </button>
                  </td>
                  <td></td>
                  <td class='font-weight-bold'>{{ Number(grandTotalUnitPrice).toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary' @click="updatePayments()">{{translations('common.update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SinglePaymentsModal :details="paymentsDetails"/>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import SinglePaymentsModal from '@/components/SinglePaymentsModal'
import { mapState } from 'vuex'

export default {
  name: 'SinglePayments',
  props: {},
  components: {
    VueElementLoading,
    SinglePaymentsModal
  },

  data () {
    return {
      paymentsID: 0,
      paymentsInfo: {},
      paymentsDetails: [],
      grandTotalUnitPrice: null,
      isLoading: false
    }
  },

  watch: {
    paymentsDetails: {
      handler (v) {
        this.calcGrandTotals()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.payments_id) {
      this.$router.replace('archive-payments')
      return
    }

    this.paymentsID = this.$route.query.payments_id
    this.getPayments()
  },

  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getBillTo']
    },
    confirmationDeleteDepositMessage () {
      return this.translations('deposit.delete_deposit')
    },
    confirmationUpdateDepositMessage () {
      return this.translations('deposit.update_deposit')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async getPayments () {
      this.isLoading = true
      try {
        let response = await this.$http.post(
          this.$api_url.payment_detail,
          { payment_id: this.paymentsID }
        )
        let $data = this.$invoiceTools.prepareResult(response.data, ['information', 'details', 'substractions'], 'SinglePayments:getPayments')
        if ($data.success === true) {
          this.paymentsInfo = $data.data.information
          this.paymentsDetails = $data.data.details
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('SinglePayments:getPayments:catch(error): ', JSON.stringify(error))
        this.$toastr.error(this.translations('deposit.notice_failed'), this.translations('common.error'))
      }
      this.isLoading = false
    },

    deleteDetail (i) {
      this.paymentsDetails.splice(i, 1)
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0

      this.paymentsDetails.forEach(v => {
        this.grandTotalUnitPrice += parseInt(v.paid)
      })
    },

    updatePayments () {
      this.$dialog.confirm(this.confirmationUpdateDepositMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          let paramUpdate = {
            payment_id: this.paymentsID,
            information: this.paymentsInfo,
            details: this.paymentsDetails
          }

          let updatePayment = await this.$http.post(this.$api_url.payment_update, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(updatePayment.data)
          console.log('SinglePayments:updatePayments: ', $data)
          if ($data.success === true) {
            this.$toastr.success(this.translations('deposit.notice_save_deposit_success'), this.translations('common.success'))
          } else {
            this.$toastr.error($data.data, this.translations('common.error'))
          }
        } catch (error) {
          console.log('SinglePayments:updatePayments:catch(error): ', error)
          this.$toastr.error(this.translations('deposit.notice_failed'), this.translations('common.error'))
        }
      })
    },

    deletePayments () {
      this.$dialog.confirm(this.confirmationDeleteDepositMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.payment_delete, { payment_id: this.paymentsID })
            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SinglePayments:deletePayments')
            if ($data.success === true) {
              this.$toastr.success(this.translations('deposit.notice_delete_deposit_success'), this.translations('common.success'))
              this.$router.replace('archive-payments')
            } else {
              this.$toastr.error($data.data, this.translations('common.error'))
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SinglePayments:deletePayments:catch(error): ', error)
            this.$toastr.error(this.translations('deposit.notice_failed'), this.translations('common.error'))
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    }

  }
}
</script>
